import ManualPage from './ManualPage';

export default ManualPage;
